import { useTranslation } from 'react-i18next'
import { Toaster } from 'sonner'
import { ToastContainer } from 'react-toastify'
import { X } from 'lucide-react'
import 'react-toastify/dist/ReactToastify.css'

/** Sonner (erpToast) + react-toastify (legacy pages). */
export function AppToaster() {
 const { t } = useTranslation()
 return (
 <>
 <Toaster
 dir="rtl"
 position="top-center"
 closeButton={false}
 duration={4000}
 gap={10}
 offset={12}
 visibleToasts={3}
 expand={false}
 className="erp-sonner-host"
 toastOptions={{
 unstyled: true,
 classNames: {
 toast: 'erp-sonner-slot',
 },
 }}
 />
 <ToastContainer
 position="top-center"
 rtl
 newestOnTop
 limit={3}
 autoClose={4000}
 hideProgressBar
 pauseOnHover
 closeOnClick
 draggable={false}
 icon={false}
 toastClassName="erp-toastify-host"
 bodyClassName="erp-toastify-body"
 closeButton={({ closeToast }) => (
 <button
 type="button"
 className="erp-toast-card__close erp-toastify-close"
 onClick={closeToast}
 aria-label={t('ui.closeNotification')}
 >
 <X className="h-4 w-4" strokeWidth={2.25} aria-hidden />
 </button>
 )}
 />
 </>
 )
}
